import { useMemo } from 'react';
import { jobStoreSelector } from '@model/Job/Job.selectors';
import { useStoreState } from '@app/store/hooks/index';
import {
  getStacks,
  sortStacksKeys,
  sortTasksByDate,
} from '@components/AppTasks/_helpers/index';
import type {
  StacksByDate,
  TStackedActivity,
} from '@components/AppTasks/_helpers/index';

export const useActivitiesStacks = (): {
  stacks: StacksByDate;
  flattenedStacks: TStackedActivity[];
} => {
  const job = useStoreState(jobStoreSelector);
  const activities = job?.statistics.activities;

  return useMemo(() => {
    const sortedActivities = sortTasksByDate(activities ?? []);
    const stacks = getStacks(sortedActivities);
    const sortedStacksKeys = sortStacksKeys(stacks);

    return {
      stacks,
      sortedStacksKeys,
      flattenedStacks: Object.values(stacks).flat(),
    };
  }, [activities]);
};
